import { environment } from '@environments/environment';

/**
 * Whether the current environment is production-like (production or staging).
 * Console output, debug logging, and mock data should be suppressed in both.
 *
 * This is the single source of truth for this check — all files should
 * import from here rather than duplicating the condition.
 */
export function isProductionLike(): boolean {
  return environment.production || environment.staging;
}
